import { toast } from "sonner";
import { Section, Chapter, Reveal } from "./Section";
import { Tilt } from "./fx";
import { BookOpen } from "lucide-react";

const BOOKS = [
  {
    title: "Preparing Minds for Ministry",
    sub: "Mental & spiritual preparation",
    desc: "Preparing individuals mentally and spiritually for the responsibility of ministry.",
    format: "Hardcover",
  },
  {
    title: "The Truth About Me",
    sub: "Reflection, honesty & growth",
    desc: "Encouraging personal reflection, honesty, growth, and greater understanding of one's journey.",
    format: "Paperback",
    url: "https://a.co/d/00fKINFJ",
  },
  {
    title: "God's GPS: Rerouting",
    sub: "Direction through detours",
    desc: "Navigating life's unexpected changes while discovering direction, purpose, and the ability to move forward.",
    format: "eBook",
    url: "https://books.by/the-kingdom-read/gods-gps",
  },
];

export default function Books() {
  const notify = (title) => toast.info(`"${title}" — online store launching soon. Join the list below to be notified.`);
  return (
    <Section id="books" testid="books-section" className="bg-white/[0.015]">
      <Chapter number="06" label="Books & Resources" testid="books-chapter"
        title={<>Wisdom for <span className="text-vg">Your Journey</span></>}
        sub="Three books created to challenge readers, develop leaders, encourage personal growth, and provide practical spiritual insight." />

      <div className="mt-16 grid md:grid-cols-3 gap-8" style={{ perspective: 1200 }}>
        {BOOKS.map((book, i) => (
          <Reveal key={book.title} delay={0.1 * i}>
            <Tilt>
              <div data-testid={`book-card-${i + 1}`}
                className="group relative rounded-2xl glass p-8 h-full flex flex-col overflow-hidden hover:border-violet-400/40 hover:shadow-[0_25px_60px_-25px_rgba(139,92,246,0.4)] transition-colors duration-300">
                <div aria-hidden className="absolute -top-20 -right-20 h-44 w-44 rounded-full bg-violet-600/15 blur-3xl group-hover:bg-amber-500/20 transition-colors duration-500" />
                <div className="absolute left-0 top-8 bottom-8 w-1 rounded-r bg-gradient-to-b from-violet-400 via-amber-400 to-violet-500" />
                <BookOpen size={22} className="text-amber-400" />
                <p className="mt-6 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-vg">{book.sub}</p>
                <h3 className="mt-3 font-display text-2xl sm:text-3xl font-extrabold text-white leading-snug">{book.title}</h3>
                <p className="mt-4 text-base text-slate-300 leading-relaxed font-normal flex-1">{book.desc}</p>
                {book.url ? (
                  <a href={book.url} target="_blank" rel="noopener noreferrer" data-testid={`book-buy-btn-${i + 1}`}
                    className="mt-8 inline-flex w-fit items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-amber-400 to-violet-500 text-white text-sm font-bold uppercase tracking-[0.15em] shadow-[0_8px_25px_-8px_rgba(139,92,246,0.6)] hover:brightness-110 hover:scale-[1.03] transition-all duration-300">
                    Order {book.format}
                  </a>
                ) : (
                  <button data-testid={`book-buy-btn-${i + 1}`} onClick={() => notify(book.title)}
                    className="mt-8 inline-flex w-fit items-center px-6 py-3 rounded-full border border-amber-400/40 text-amber-300 text-sm font-bold uppercase tracking-[0.15em] hover:bg-gradient-to-r hover:from-amber-400 hover:to-violet-500 hover:text-white hover:border-transparent transition-all duration-300">
                    Order {book.format}
                  </button>
                )}
              </div>
            </Tilt>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
